import React, { useEffect } from "react";

import { usePolicemanRegister } from "contexts/register/PolicemanContext";

import Input from "../../../Input";
import MaskedInput from "../../../MaskedInput";

import * as S from "./styles";

function BankingForm({ updateBankingData }: any) {
  const { bankingData, setBankingData, errors, removeError } =
    usePolicemanRegister();

  useEffect(() => {
    if (updateBankingData) {
      setBankingData(updateBankingData);
    }
  }, []);

  return (
    <S.Wrapper>
      <S.Form>
        <Input
          id="bank"
          name="bank"
          defaultValue={
            bankingData?.accountData.bank
              ? bankingData?.accountData.bank
              : updateBankingData?.accountData.bank
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setBankingData((value) => {
              value.accountData.bank = event.target.value;
              return value;
            });
          }}
          label="Código do banco"
          required={true}
          maxLength={3}
          type="text"
          error={errors["bankingData.accountData.bank"]}
          apiErrorName="bankingData.accountData.bank"
          handleApiErrorRemove={() =>
            removeError("bankingData.accountData.bank")
          }
        />
        <S.DocumentContainer>
          <MaskedInput
            id="account"
            name="account"
            defaultValue={
              bankingData.accountData.account
                ? bankingData.accountData.account
                : updateBankingData?.accountData.account
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setBankingData((value) => {
                value.accountData.account = event.target.value;
                return value;
              });
            }}
            label="Conta"
            required={true}
            type="text"
            error={errors["bankingData.accountData.account"]}
            apiErrorName="bankingData.accountData.account"
            handleApiErrorRemove={() =>
              removeError("bankingData.accountData.account")
            }
          />
          <MaskedInput
            id="agency"
            name="agency"
            defaultValue={
              bankingData?.accountData.agency
                ? bankingData?.accountData.agency
                : updateBankingData?.accountData.agency
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setBankingData((value) => {
                value.accountData.agency = event.target.value;
                return value;
              });
            }}
            label="Agência"
            required={true}
            type="text"
            error={errors["bankingData.accountData.agency"]}
            apiErrorName="bankingData.accountData.agency"
            handleApiErrorRemove={() =>
              removeError("bankingData.accountData.agency")
            }
          />
        </S.DocumentContainer>
        <Input
          id="pix"
          name="pix"
          defaultValue={
            bankingData?.accountData.pix
              ? bankingData?.accountData.pix
              : updateBankingData?.accountData.pix
          }
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setBankingData((value) => {
              value.accountData.pix = event.target.value;
              return value;
            });
          }}
          label="Pix"
          required={true}
          type="text"
          error={errors["bankingData.accountData.pix"]}
          apiErrorName="bankingData.accountData.pix"
          handleApiErrorRemove={() =>
            removeError("bankingData.accountData.pix")
          }
        />
      </S.Form>
    </S.Wrapper>
  );
}

export { BankingForm };
